export type PaymentMethod =
    | 'visa'
    | 'vietqr'
    | 'vnpayqr'
    | 'zalopay'
    | 'momo'
    | 'atm'
    | '9pay'
    | 'banking'
    | 'pay_later';

export enum PaymentMethodEnum {
    VISA = 'visa',
    VIET_QR = 'vietqr',
    VNPAY_QR = 'vnpayqr',
    ZALO_PAY = 'zalopay',
    ATM = 'atm',
    MOMO = 'momo',
    '9PAY' = '9pay',
    BANKING = 'banking',
    PAY_LATER = 'pay_later',
}

export enum PaymentTypeEnum {
    /** Chuyển khoản */
    COLLECTION = 'COLLECTION',
    /** Thẻ nội địa */
    ATM_CARD = 'ATM_CARD',
    /** Thẻ quốc tế */
    CREDIT_CARD = 'CREDIT_CARD',
    /** Trả sau */
    POSTPAID = 'POSTPAID',
}

export interface PaymentResponse9Pay {
    amount: number;
    amount_foreign: number;
    amount_original: number;
    amount_request: number;
    bank: string;
    card_brand: string;
    card_info: string;
    created_at: any;
    currency: string;
    description: string;
    error_code: number;
    exc_rate: any;
    failure_reason: string;
    foreign_currency: any;
    invoice_no: string;
    lang: string;
    method: string;
    payment_no: number;
    profile_id: string;
    status: number;
    tenor: string;
}
